import React, { useState, useEffect, useRef } from 'react';
import '../../css/modal.css';
import { toast } from 'react-toastify';
import { User } from '../../types/User';
import { assignBooking } from '../../api/Booking';

interface AssignmentModalProps {
  bookingId: number | string;
  users: User[];
  onAssign: (bookingId: number | string, userId: number) => void;
  onClose: () => void;
}

const AssignmentModal: React.FC<AssignmentModalProps> = ({ bookingId, users, onAssign, onClose }) => {
  const [selectedUserId, setSelectedUserId] = useState<number | ''>('');
  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    selectRef.current?.focus();
  }, []);

  const handleAssign = () => {
    if (selectedUserId === '') {
      toast.error('Please select a user to assign the booking.');
      return;
    }
    assignBooking(bookingId, selectedUserId)
    .then(() => onAssign(bookingId, selectedUserId))
    .then(() => toast.success('Booking assigned successfully'))
    .catch(() => toast.error('Booking assignment failed'))

    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal slide-in-right">
        <div className="modal-header">
          <h2>Assign Booking</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <label>
            Assign to<span className="required">*</span>
          </label>
          <select
            ref={selectRef}
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(Number(e.target.value))}
          >
            <option value="">-- Select User --</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>{user.name}</option>
            ))}
          </select>
          <div className="modal-actions">
            <button onClick={onClose}>Cancel</button>
            <button onClick={handleAssign}>Assign</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentModal;
